import { transformCurrencyAmountDto } from './currency-amount'
import { transformBuyerProtectionFee, transformShippingFee } from './escrow-fees'
import {
  PriceEstimateWithFeesDto,
  PriceEstimateWithFeesModel,
} from '../types/price-estimate-with-fees'

export const transformPriceEstimateWithFees = (
  dto: PriceEstimateWithFeesDto,
): PriceEstimateWithFeesModel => ({
  totalPrice: transformCurrencyAmountDto(dto.total_price),
  buyerProtection: transformBuyerProtectionFee(dto.buyer_protection),
  shipping: transformShippingFee(dto.shipping),
})
